import { TerminalButton3 } from "@/components/Buttons"
import { CreditCard, Landmark } from "lucide-react"

export default function ButtonGroup({ allowedPaymentMethods, formType, setFormType }:
    { allowedPaymentMethods: string[], formType: any, setFormType: Function }) {
    const textClassNames = "text-xxs"
    return (
        <div className="flex space-x-3 mb-3">
            {allowedPaymentMethods.includes('card') &&
                <TerminalButton3 onClick={() => setFormType('card-form')}
                    selected={formType === 'card-form'} >
                    <CreditCard />
                    <p className={textClassNames}>Card</p>
                </TerminalButton3>
            }
            {allowedPaymentMethods.includes('ach') &&
                <TerminalButton3 onClick={() => setFormType('bank-form')}
                    selected={formType === 'bank-form'} >
                    <Landmark />
                    <p className={textClassNames}>Bank Account</p>
                </TerminalButton3>
            }
        </div>
    )
}